import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/auth";
import store from "@/store";
import i18n from "@/lang";
import SiteRouter from "./config/SiteRouter";
import AssetRouter from "./config/AssetRouter";
import MineRouter from "./config/MineRouter";
import Product from "./config/Product";
import Quotation from "./config/Quotation";
import walletRouter from "./config/walletRouter";
import welfare from "./config/welfare";
import Options from "./config/Options";
import football from "./config/footballRouter";
import Recruitment from "./config/Recruitment";
import activity from "./config/activityRouter";
import lottery from "./config/lotteryRouter";
import { ethers } from "ethers";

Vue.use(Router);

// Routes
const constantRoutes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home"),
    meta: { title: "首页" },
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test"),
    meta: { title: "测试钱包登录" },
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import("@/views/maintenance"),
    meta: { title: "维护" },
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/service"),
    meta: { title: "客服" },
  },
  {
    path: "/wp",
    name: "white paper",
    component: () => import("@/views/wp"),
    meta: { title: "白皮书" },
  },
  {
    path: "/conditions",
    name: "conditions",
    component: () => import("@/views/conditions/conditions"),
    meta: { title: "行情" },
  },
  ...SiteRouter,
  ...AssetRouter,
  ...MineRouter,
  ...Product,
  ...Quotation,
  ...walletRouter,
  ...welfare,
  ...Options,
  ...football,
  ...Recruitment,
  ...activity,
  ...lottery,
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    routes: constantRoutes,
  });

const router = createRouter();

function quickFixBlackScreen() {
  // 方法1: 滚动修复
  const currentScroll = window.pageYOffset;
  window.scrollTo(0, currentScroll + 1);
  setTimeout(() => window.scrollTo(0, currentScroll), 0);

  // 方法2: 重绘修复
  document.body.style.display = "none";
  document.body.offsetHeight;
  document.body.style.display = "";

  // 方法3: 缩放修复（iOS专用）
  const meta = document.querySelector('meta[name="viewport"]');
  if (meta) {
    const content = meta.getAttribute("content");
    meta.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    );
    setTimeout(() => {
      meta.setAttribute("content", content);
    }, 10);
  }
}

const whiteList = [
  "/login",
  "/region",
  "/register",
  "/registerCode",
  "/reset",
  "/resetCode",
  "/SetLanguage",
  "/home",
  "/downloadApp",
  "/fiatCurrencyPayment",
  "/fiatCurrencyBehalf",
];

router.beforeEach((to, from, next) => {
  // dynamically set the title content
  // document.title = to.meta.title ? `${i18n.t(to.meta.title)} | ${window.global.titleName}` : window.global.titleName
  // document.title = `${i18n.t(to.meta.title)}`;
  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      setTimeout(quickFixBlackScreen, 100);
    } else {
      next();
      setTimeout(quickFixBlackScreen, 100);
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    // in the free login whitelist, go directly
    next();
    setTimeout(quickFixBlackScreen, 100);
  } else {
    // other pages that do not have permission to access are redirected to the login page.
    // store.dispatch('resetInfo').then(() => {
    //   next(`/login`)
    // })
    next();
    setTimeout(quickFixBlackScreen, 100);
  }
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  //
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js